import {
  CloseIcon,
  FilledButton,
  OutlinedButton,
} from '@/components/UI/Button';
import { StyledDialog } from '@/components/UI/Dialog';
import { Box, Typography } from '@mui/material';

import { IconCloseMS } from '../../../../constants/icons';

interface EndSessionConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
}

export function EndSessionConfirmDialog({
  open,
  onClose,
  onConfirm,
  loading = false,
}: EndSessionConfirmDialogProps): JSX.Element {
  return (
    <StyledDialog open={open} onClose={onClose}>
      <Box
        p="40px"
        width="606px"
        display="flex"
        flexDirection="column"
        gap="20px"
        position="relative"
        boxSizing="border-box"
      >
        <CloseIcon onClick={onClose}>{IconCloseMS}</CloseIcon>

        <Box>
          <Typography variant="h6" fontWeight={600} mb={1}>
            Encerrar sessão ativa?
          </Typography>
          <Typography
            sx={{
              fontSize: '16px',
              fontWeight: 400,
              lineHeight: 1.4,
            }}
          >
            Isso vai interromper o acesso da equipe de suporte imediatamente. Se
            ainda precisar de ajuda, uma nova solicitação deverá ser enviada.
          </Typography>
        </Box>

        <Box display="flex" gap={2} justifyContent="center" mt={1}>
          <OutlinedButton width="ms" onClick={onClose}>
            Voltar
          </OutlinedButton>
          <FilledButton
            model="error"
            width="ms"
            onClick={onConfirm}
            disabled={loading}
          >
            Encerrar sessão
          </FilledButton>
        </Box>
      </Box>
    </StyledDialog>
  );
}
